type SearchableField = string | null | undefined;

/**
 * Decides whether a record matches a search string across its searchable fields.
 *
 * The fields are joined into a single string and every whitespace/comma-separated term
 * must appear somewhere in it, so "John Doe" matches a record whose first name is "John"
 * and surname is "Doe".
 */
export function matchesClientSearch(searchableFields: SearchableField[], search: string): boolean {
  if (search.trim() === '') return true;

  const searchableText = searchableFields.filter(Boolean).join(' ').toLowerCase();
  return search
    .toLowerCase()
    .split(/[\s,]+/)
    .filter(Boolean)
    .every(term => searchableText.includes(term));
}
